import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../core/services/api.service';
import {
  AutomationMetadataDto,
  AutomationRuleDto,
  CreateAutomationRuleRequest,
  PmAutomationExecutionLogDto
} from './automation.models';

@Injectable({ providedIn: 'root' })
export class AutomationService {
  private readonly api = inject(ApiService);
  private readonly base = 'v1/pm/automation-rules';

  list(projectId?: string): Observable<AutomationRuleDto[]> {
    return this.api.get<AutomationRuleDto[]>(this.base, projectId ? { projectId } : undefined);
  }

  create(body: CreateAutomationRuleRequest): Observable<AutomationRuleDto> {
    return this.api.post<AutomationRuleDto>(this.base, body);
  }

  update(id: string, body: CreateAutomationRuleRequest & { isEnabled?: boolean }): Observable<AutomationRuleDto> {
    return this.api.put<AutomationRuleDto>(`${this.base}/${id}`, body);
  }

  delete(id: string): Observable<unknown> {
    return this.api.delete(`${this.base}/${id}`);
  }

  getMetadata(): Observable<AutomationMetadataDto> {
    return this.api.get<AutomationMetadataDto>(`${this.base}/metadata`);
  }

  listExecutions(projectId?: string, take = 50): Observable<PmAutomationExecutionLogDto[]> {
    return this.api.get<PmAutomationExecutionLogDto[]>(`${this.base}/executions`, { ...(projectId ? { projectId } : {}), take });
  }

  listRuleExecutions(ruleId: string, take = 50): Observable<PmAutomationExecutionLogDto[]> {
    return this.api.get<PmAutomationExecutionLogDto[]>(`${this.base}/${ruleId}/executions`, { take });
  }
}
